/**
 * 摘要文本验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const summaryTextValidationConfig: ValidationConfig = {
  fields: [{ field: 'x', type: ['string', 'date', 'number'], required: true }],
  businessRules: [
    {
      name: 'summary-text-single-data-point',
      validator: data => Array.isArray(data) && data.length === 1,
      message: 'Summary text requires exactly one data point',
      suggestion: 'Provide exactly one data point for summary text display',
      severity: 'error'
    },
    {
      name: 'summary-text-content-valid',
      validator: (data, layer) => {
        if (!Array.isArray(data) || data.length === 0) {
          return false;
        }

        const { encoding } = layer;
        const content = data[0][encoding?.x as string];
        return content !== null && content !== undefined && content !== '';
      },
      message: 'Summary text content cannot be empty',
      suggestion: 'Ensure the x field contains valid non-empty content',
      severity: 'error'
    },
    {
      name: 'summary-text-reasonable-length',
      validator: (data, layer) => {
        if (!Array.isArray(data) || data.length === 0) {
          return true;
        }

        const { encoding } = layer;
        const content = data[0][encoding?.x as string];
        return !content || content.toString().length <= 500;
      },
      message: 'Summary text content is very long',
      suggestion: 'Consider limiting summary text to 500 characters for better display',
      severity: 'warning'
    },
    {
      name: 'summary-text-date-format',
      validator: (data, layer) => {
        if (!Array.isArray(data) || data.length === 0) {
          return true;
        }

        const { encoding } = layer;
        const content = data[0][encoding?.x as string];

        // 如果内容看起来像日期，验证日期格式
        if (typeof content === 'string' && /^\d{4}-\d{2}-\d{2}/.test(content)) {
          const date = new Date(content);
          return !Number.isNaN(date.getTime());
        }

        return true;
      },
      message: 'Invalid date format in summary text',
      suggestion: 'Use valid date format (ISO format recommended: YYYY-MM-DD)',
      severity: 'warning'
    }
  ]
};
